import React from "react";
import RadioButtonQuest from "../../../../UI/RadioButtonQuest";

const HowOftenExceedCredit = ({ onselectAnswer, reff, display }) => {
  const labelclicked = async (e) => {
    onselectAnswer(e);
  };

  return (
    <>
      <div style={{ display: display }}>
        <div className="radio-box question animated fadeInUp" ref={reff}>
          <h3>
            How often did you exceed you overdraft limit?
          </h3>
          <RadioButtonQuest
            key="Always146"
            className="radio-buttons"
            labelName="Always"
            labelClassName="option_but next-2"
            onClick={labelclicked}
            value="257"
            name="oftenexceedCredit"
            id="opt146"
            dataQuestId={96}
            dataAnsId={257}
            dataAnsLabel="Always"
          />
          <RadioButtonQuest
            key="Sometimes147"
            className="radio-button"
            labelName="Sometimes"
            labelClassName="option_but next-2"
            onClick={labelclicked}
            value="258"
            name="oftenexceedCredit"
            id="opt147"
            dataQuestId={96}
            dataAnsId={258}
            dataAnsLabel="Sometimes"
          />
          <RadioButtonQuest
            key="Rarely148"
            className="radio-button"
            labelName="Rarely"
            labelClassName="option_but next-2"
            onClick={labelclicked}
            value="259"
            name="oftenexceedCredit"
            id="opt148"
            dataQuestId={96}
            dataAnsId={259}
            dataAnsLabel="Rarely"
          />
          <RadioButtonQuest
            key="Never149"
            className="radio-button"
            labelName="Never"
            labelClassName="option_but next-2"
            onClick={labelclicked}
            value="260"
            name="oftenexceedCredit"
            id="opt149"
            dataQuestId={96}
            dataAnsId={260}
            dataAnsLabel="Never"
          />
        </div>
      </div>
    </>
  );
};

export default HowOftenExceedCredit;
